import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { logEvent } from "firebase/analytics";
import { analytics } from './components/firebase';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

logEvent(analytics,'indexappstart', {
  
  starting: 'starting',
  // Add more parameters as needed
});
reportWebVitals();
